import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SidebarNavComponent } from '../../sidebar-nav/sidebar-nav.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

sidebar: SidebarNavComponent

  constructor(private _elementRef : ElementRef) { }


  ngOnInit(): void {
    this.sidebar = new SidebarNavComponent();
  }

  navigateNext()
  {

    this.sidebar.onClick();
  }

}
